'use client';

import FloatingVoiceV1 from '@/components/voice/FloatingVoiceV1';

export function BusinessPageFloatingVoice({
  agentId,
  tenantId,
  tenantSlug,
  businessName,
  agentName,
}: {
  agentId: string;
  tenantId: string;
  tenantSlug: string;
  businessName: string;
  agentName: string;
}) {
  return (
    <FloatingVoiceV1
      surface="tenant_business_page"
      variant="embedded-business-page"
      agentId={agentId}
      tenantId={tenantId}
      tenantSlug={tenantSlug}
      dynamicVariables={{
        business_name: businessName,
        agent_name: agentName,
      }}
      labels={{
        idle: '',
      }}
      helperText={{
        // Idle line intentionally empty: the ring itself shows "Tap to Talk",
        // so a second "tap" caption would be redundant. Active states still
        // surface status feedback above the ring.
        idle: '',
        connecting: `Connecting you to ${agentName}…`,
        listening: `${agentName} is listening…`,
        speaking: `${agentName} is responding…`,
        ended: 'Call ended. Tap to talk again.',
      }}
      postCall={{ mode: 'restart' }}
      visualReveal="immediate"
      testId="business-page-floating-voice-v1"
    />
  );
}
